export default "__VITE_ASSET__DKcz8SCd__"